import React, { FC } from 'react'
import { useMutation } from '@apollo/client'
import { Button } from 'design-system'
import { useDispatch } from 'react-redux'

import { setBanner } from 'src/store/action-methods/banner'

import { JOIN_BOARD_WITH_TOKEN } from 'src/graphql/board/shareLink'

interface JoinBoardButtonProps {
  boardId: string
  tokenId: string
  setBoardJoined: (_: boolean) => void
}

export const JoinBoardButton: FC<JoinBoardButtonProps> = ({
  boardId,
  tokenId,
  setBoardJoined
}) => {
  const dispatch = useDispatch()

  const [joinBoardWithTokenMutation, { loading }] = useMutation(
    JOIN_BOARD_WITH_TOKEN
  )

  const joinBoardWithToken = async () => {
    try {
      await joinBoardWithTokenMutation({
        variables: { boardId, tokenId }
      })
      setBoardJoined(true)
    } catch (_) {
      setBanner({
        open: true,
        error: true,
        msg: 'We were unable to join the community. Please try again in a few minutes.',
        assertive: true
      })(dispatch)
    }
  }

  return (
    <Button
      buttonType="primary"
      onClick={joinBoardWithToken}
      disabled={loading}>
      Join Community
    </Button>
  )
}
